export const asynchronousJobsDocumentationMarkdown = `
# Notable Classic Job Node

Notable has built out multiple point solutions to export data into the EHR.

This block exposes those solutions for use in the flow.
Use this block to trigger these automations and wait for their completion.

## How to Use

First select the type of data to export (Forms, Previsit Planning, etc).
The UI will automatically update to ask for the relevant data it needs such as patient name, encounter information, etc.
Use the previous blocks' data to fill in this information.
If your patient information is stored in a block named patient, to get their first name you might do \`{{patient.data.firstName}}\`

## Necessary Outside Configuration

The block makes use of notable's existing system to intelligently run automations in the right ehr environments.
If you wish to make changes to this routing go to [ehr-instances](https://app.notablehealth.com/staff/app#/ehr-instances)

## Timeouts

These automations run as fast as they can but if too many automations are kicked off at once, Notable will be unable to complete all automations in a timely manner.
Set a sensible timeout to ensure that automations are given the time to start and complete.
Notable will attempt to start a job as early as it can but if it cannot complete a job within before the timout expires, the block will "fail".
However, that does not always mean that the job has failed. If the job has started, it will continue regardless of the timeout of the block.
`;
